import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import FailedExternalPageUI from './FailedExternalPageUI'

class FailedExternalPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      externalApiCallLogList: null,
      lastKey: null,
      hasMore: false,
      gettingMore: false,
      reinitiateSubmitted: false,
      reinitiateSuccessMsg: null,
      selectedRequestId: null,
      currentPage: 1,
      pageHistory: [], // Array to store keys used to fetch each page
      pageData: {}, // Object to store data for each page
      hasPrevious: false
    }
  }

  componentDidMount() {
    this.getFailedExternalApiCalls(this.props.context)
  }

  render() {    
    return (
      <FailedExternalPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        externalApiCallLogList={this.state.externalApiCallLogList}
        lastKey={this.state.lastKey}
        hasMore={this.state.hasMore}
        hasPrevious={this.state.hasPrevious}
        gettingMore={this.state.gettingMore}
        currentPage={this.state.currentPage}
        reinitiateSubmitted={this.state.reinitiateSubmitted}
        reinitiateSuccessMsg={this.state.reinitiateSuccessMsg}
        selectedRequestId={this.state.selectedRequestId}
        onRefreshClick={this.onRefreshClick}
        onNextClick={this.onNextClick}
        onPreviousClick={this.onPreviousClick}
        onReinitiateClick={this.onReinitiateClick}
      />
    )
  }

  getFailedExternalApiCalls(context, lastEvaluatedKey = null) {
    const cacheManager = new CacheManager({
      resource: '/api/su/externalApiCallLog',
      cacheKey: CacheKeys.FailedExternalApiCalls(lastEvaluatedKey),
      callback: this.getFailedExternalApiCallsCallback,
      ttlInSecs: 600,
    })
    
    let requestParams = {}
    if (lastEvaluatedKey) {
      requestParams.lastEvaluatedKey = lastEvaluatedKey
      requestParams.limit = 10
    } else {
      requestParams.limit = 10
    }
    
    if (lastEvaluatedKey) {
      CacheManager.removeObject(CacheKeys.FailedExternalApiCalls(lastEvaluatedKey))
    }
    
    cacheManager.getObject2(context, null, requestParams)
  }

  getFailedExternalApiCallsCallback = (response) => {
    // Store the data for the current page
    const pageData = { ...this.state.pageData }
    pageData[this.state.currentPage] = {
      externalApiCallLogList: response.externalApiCallLogList || [],
      lastKey: response.lastKey,
      hasMore: response.hasMore,
      errorList: response.errorList
    }
    
    this.setState({
      errorList: response.errorList,
      externalApiCallLogList: response.externalApiCallLogList || [],
      lastKey: response.lastKey,
      hasMore: response.hasMore,
      gettingMore: false,
      pageData: pageData,
      hasPrevious: this.state.currentPage > 1
    })
  }

  onNextClick = () => {
    if (this.state.gettingMore || !this.state.hasMore || !this.state.lastKey) {
      return
    }

    // Store the key that was used to fetch the current page
    const keyToStore = this.state.currentPage === 1 ? null : this.state.lastKey
    const newPageHistory = [...this.state.pageHistory, keyToStore]
    

    
    this.setState({ 
      gettingMore: true,
      pageHistory: newPageHistory,
      hasPrevious: true,
      currentPage: this.state.currentPage + 1
    }, () => {
      this.getFailedExternalApiCalls(this.props.context, this.state.lastKey)
    })
  }

  onPreviousClick = () => {
    if (this.state.gettingMore || !this.state.hasPrevious || this.state.pageHistory.length === 0) {
      return
    }

    const previousPage = this.state.currentPage - 1
    
    // Prevent going below page 1
    if (previousPage < 1) {
      return
    }
    
    const previousPageData = this.state.pageData[previousPage]
    
    if (previousPageData) {
      // Use cached data for previous page
      this.setState({ 
        gettingMore: true,
        hasPrevious: previousPage > 1,
        currentPage: previousPage,
        externalApiCallLogList: previousPageData.externalApiCallLogList,
        lastKey: previousPageData.lastKey,
        hasMore: previousPageData.hasMore,
        errorList: previousPageData.errorList,
        gettingMore: false
      })
    } else {
      // Fallback to API call if data not cached
      const newPageHistory = [...this.state.pageHistory]
      const previousKey = newPageHistory[newPageHistory.length - 1]
      newPageHistory.pop()
      
      this.setState({ 
        gettingMore: true,
        pageHistory: newPageHistory,
        hasPrevious: previousPage > 1,
        currentPage: previousPage
      }, () => {
        this.getFailedExternalApiCalls(this.props.context, previousKey)
      })
    }
  }

  onReinitiateClick = (event) => {
    const requestId = event.currentTarget.getAttribute('data-request-id')
    if (!requestId) {
      return
    }

    
    this.setState({
      reinitiateSubmitted: true,
      reinitiateSuccessMsg: null,
      errorList: null,
      selectedRequestId: requestId
    })


    
    const retryUrl = `/api/su/externalApiCallLog/retryFailed/${requestId}`
    RestApiUtils.post(this.props.context, retryUrl, this.onReinitiateCallback, null)
  }

  onReinitiateCallback = (response) => {
    const errorList = response.errorList || []

    this.setState({
      reinitiateSuccessMsg: response.success,
      errorList: errorList.length > 0 ? errorList : null,
      reinitiateSubmitted: false
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ reinitiateSuccessMsg: null })
        this.onRefreshClick()
      }, 2000)
    } else {
      setTimeout(() => {
        this.setState({ errorList: null })
      }, 5000)
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.FailedExternalApiCalls())
    this.setState({
      errorList: null,
      externalApiCallLogList: null,
      lastKey: null,
      hasMore: false,
      reinitiateSuccessMsg: null,
      currentPage: 1,
      pageHistory: [],
      pageData: {},
      hasPrevious: false
    }, () => {
      this.getFailedExternalApiCalls(this.props.context)
    })
  }
}

export default FailedExternalPageSF